module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAYCAYAAADOMhxqAAAA/0lEQVQ4T5XU3Q2CMBAHcAuvQNxA2MAESHizTKAbGCfQURzBEdyAvpMQNiBuQAhvBOqdsYSPFgrP/9+1vWshvu+XnPNHlmWvncZHADwhdwd000EEiwLC6lcd9AMCATibphmnaZqrdtcDXTQCiIIgeHddd1KtNAOU0n1VVQzsQYZmAFcZIsdxPMZYKc4kBUNkGAa3LCsWSAlUaBEgiqLIbZomJ4QUuNIqQBSG4RE6xxBpg7ZtE7CfVYDVRRg6RlcPXdd1AtshGMZOLbZ1GsbzKAeHYbiMnm3b7uLgcMoiDEOj05srvXxQmcrCsy39H9JFFR4BnXAPNj3RzT+Brb+ZL84avopDUdn4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/jt_right.png
// module id = mgeM
// module chunks = 0